import { ReportType } from './transmissionReport';

export enum ActivityFeedType {
  TRANSMISSION = 'transmission',
  CLINICAL_NOTE = 'clinical_note',
  REGAL_CALL = 'regal_call',
  PATIENT_STATUS = 'patient_status',
  POSTGRID = 'postgrid_email',
  RETELL_CALLS = 'retell_calls'
}

export interface ActivityFeedItem {
  eventId: string;
  patientId: string;
  eventType: ActivityFeedType;
  eventDate: string;
  data: {
    id: number | string;
    transmissionType?: ReportType;
    transmissionDate?: string;
    color?: string;
    rhythmSignDate?: string;
    truncatedNoteText?: string;
    lastUpdatedDate?: string;
    lastUpdatedBy?: string;
    direction?: 'INBOUND' | 'OUTBOUND';
    duration?: number;
    disposition?: string;
    callNotes?: string;
    agentName?: string;
    completedTimestamp?: string;
    patientStatus?: string;
    dateOfService?: string;
    total_duration_seconds?: number;
    case_type?: string;
    disconnect_reason?: string;
  };
}

export interface FilterOption {
  id: string;
  label: string;
  checked: boolean;
}

export interface ActivityFeedResponse {
  data: ActivityFeedItem[];
  pagination: {
    page: number;
    pageSize: number;
    count: number;
  };
}

export interface ActivityFeedQuery {
  patientId: string;
  page?: number;
  pageSize?: number;
  filters?: string[];
}

export enum ActivityFeedFilter {
  INBOUND = 'inbound',
  OUTBOUND = 'outbound',
  RED = 'red',
  YELLOW = 'yellow',
  REMOTE = 'remote',
  IN_CLINIC = 'in-clinic',
  SUPPORT_MESSAGE = 'support-message',
  CLINICAL_NOTES = 'clinical-notes',
  PATIENT_STATUS = 'patient-status',
  POST_GRID_LETTERS = 'postgrid',
  RETELL_CALLS = 'retell-calls'
}

export const getActivityEventTypeDisplay = (type: ActivityFeedType): string => {
  switch (type) {
    case ActivityFeedType.TRANSMISSION:
      return 'Transmission';
    case ActivityFeedType.CLINICAL_NOTE:
      return 'Clinical Note';
    case ActivityFeedType.REGAL_CALL:
      return 'Call';
    case ActivityFeedType.PATIENT_STATUS:
      return 'Patient Status';
    case ActivityFeedType.POSTGRID:
      return 'Postgrid';
    case ActivityFeedType.RETELL_CALLS:
      return 'Retell Call';
    default:
      return 'Unknown Activity';
  }
};
